export default __webpack_public_path__ + "static/cesar-varela-resume-e42d7947cbbe3f4305fdd7724cd3c43e.pdf";